import * as services from './user.queries';

export default services;
